export default __webpack_public_path__ + "static/media/free7.93811109.svg";